import { render, staticRenderFns } from "./PermissionsAccountsForm.vue?vue&type=template&id=195df9d2&scoped=true&"
import script from "./PermissionsAccountsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsAccountsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195df9d2",
  null
  
)

export default component.exports